export default __webpack_public_path__ + "static/media/spotlight_autochtone_664x830_en.eb541a3b.jpg";